import { alpha, type Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material';

export function adminDataGridSx(theme: Theme): SxProps<Theme> {
  const isLight = theme.palette.mode === 'light';
  const hover = alpha(theme.palette.primary.main, isLight ? 0.045 : 0.1);

  return {
    border: 'none',
    bgcolor: 'transparent',
    '& .MuiDataGrid-row:hover': {
      bgcolor: `${hover} !important`,
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
    // Collapse trailing empty filler so Manage is not followed by blank space.
    '& .MuiDataGrid-filler, & .MuiDataGrid-scrollbarFiller, & .MuiDataGrid-columnHeader--filler': {
      display: 'none',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      boxSizing: 'border-box',
    },
  };
}
